var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConferenceFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1137_1456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.449219,
    y: 0.349121,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1137_1456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4492 26.5991C19.7617 26.5991 19.1732 26.3543 18.6836 25.8647C18.194 25.3752 17.9492 24.7866 17.9492 24.0991V19.0991C17.9492 18.4116 18.194 17.8231 18.6836 17.3335C19.1732 16.8439 19.7617 16.5991 20.4492 16.5991H25.4492C26.1367 16.5991 26.7253 16.8439 27.2148 17.3335C27.7044 17.8231 27.9492 18.4116 27.9492 19.0991V24.0991C27.9492 24.7866 27.7044 25.3752 27.2148 25.8647C26.7253 26.3543 26.1367 26.5991 25.4492 26.5991H20.4492ZM2.94922 22.8491V20.3491H14.1992V22.8491H2.94922ZM20.4492 14.0991C19.7617 14.0991 19.1732 13.8543 18.6836 13.3647C18.194 12.8752 17.9492 12.2866 17.9492 11.5991V6.59912C17.9492 5.91162 18.194 5.32308 18.6836 4.8335C19.1732 4.34391 19.7617 4.09912 20.4492 4.09912H25.4492C26.1367 4.09912 26.7253 4.34391 27.2148 4.8335C27.7044 5.32308 27.9492 5.91162 27.9492 6.59912V11.5991C27.9492 12.2866 27.7044 12.8752 27.2148 13.3647C26.7253 13.8543 26.1367 14.0991 25.4492 14.0991H20.4492ZM2.94922 10.3491V7.84912H14.1992V10.3491H2.94922Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceFilled);
export default __webpack_public_path__ + "static/media/conferenceFilled.18024ce824cdd4a69e753bc6108fb4da.svg";
export { ForwardRef as ReactComponent };